import { linkToMonitoringPage } from "../../../monitoring/links";
import { linkToChild } from "../../links";

export function linkToChildOverviewPage(userId: string = ":userId") {
  return `${linkToChild(userId)}/overview`;
}

export function linkToOverviewPage(childId?: string) {
  return !!childId ? linkToChildOverviewPage(childId) : linkToMonitoringPage();
}
